import type { EstadoGastoComun } from '@condo/contracts';
import { Badge, type BadgeProps } from '@/components/ui/badge';

const ESTADO_VARIANT: Record<EstadoGastoComun, BadgeProps['variant']> = {
  borrador: 'neutral',
  emitido: 'primary',
  parcialmente_pagado: 'warning',
  pagado: 'success',
  anulado: 'danger',
};

const ESTADO_LABEL: Record<EstadoGastoComun, string> = {
  borrador: 'Borrador',
  emitido: 'Emitido',
  parcialmente_pagado: 'Parcialmente pagado',
  pagado: 'Pagado',
  anulado: 'Anulado',
};

interface Props {
  estado: EstadoGastoComun;
  className?: string;
}

export function EstadoBadge({ estado, className }: Props) {
  return (
    <Badge variant={ESTADO_VARIANT[estado]} className={className}>
      {ESTADO_LABEL[estado]}
    </Badge>
  );
}
